import Splide from "@splidejs/splide";

export const initSliders = () => {
  if (document.querySelector("#splide-left") !== null) {
    new Splide("#splide-left", {
      type: "loop",
      autoplay: true,
      arrows: false,
      pagination: false,
      prev: "splide__arrow--prev your-class-prev",
      next: "splide__arrow--next your-class-next",
      interval: 2700,
      speed: 1800,
    }).mount();
  }

  if (document.querySelector("#splide-right") !== null) {
    new Splide("#splide-right", {
      type: "loop",
      autoplay: true,
      arrows: false,
      pagination: false,
      prev: "splide__arrow--prev your-class-prev",
      next: "splide__arrow--next your-class-next",
      interval: 3000,
      speed: 2000,
    }).mount();
  }
};
